import type { ApiResponse } from "../shared/types";

function clientId(): string {
  const key = "pct_client_id";
  let value = localStorage.getItem(key);
  if (!value) {
    value = crypto.randomUUID().replace(/-/g, "");
    localStorage.setItem(key, value);
  }
  return value;
}

export class ApiError extends Error {
  constructor(message: string, readonly code: string, readonly requestId?: string) {
    super(message);
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: "same-origin",
    headers: {
      "content-type": "application/json",
      "x-client-id": clientId(),
      ...init?.headers
    }
  });
  const payload = (await response.json()) as ApiResponse<T>;
  if (!payload.ok) throw new ApiError(payload.error.message, payload.error.code, payload.requestId);
  return payload.data;
}
